import gql from 'graphql-tag';

export const employeeSignComplete = gql`
  mutation employeeSignComplete($payLoad: employeeSignCompleteIp!) {
    employeeSignComplete(payLoad: $payLoad) {
      status
    }
  }
`;

export const employerSignComplete = gql`
  mutation employerSignComplete($payLoad: employerSignCompleteIp!) {
    employerSignComplete(payLoad: $payLoad) {
      status
    }
  }
`;
